import React from 'react';
import { Link } from 'react-router-dom';
import { Artwork } from '../../data/products';
import './ArtworkCard.css';

interface ArtworkCardProps {
  artwork: Artwork;
}

const ArtworkCard: React.FC<ArtworkCardProps> = ({ artwork }) => (
  <Link to={`/art/${artwork.handle}`} className="artwork-card" aria-label={`${artwork.title} — ${artwork.type}`}>
    <div className="artwork-card__image-wrap">
      <img
        src={artwork.images[0]}
        alt={`${artwork.title}${artwork.medium ? ` — ${artwork.medium}` : ''}`}
        className="artwork-card__image"
        width={500}
        height={625}
        loading="lazy"
      />
      <span className={`artwork-card__type-badge artwork-card__type-badge--${artwork.type.toLowerCase()}`}>
        {artwork.type}
      </span>
    </div>
    <div className="artwork-card__info">
      <h3 className="artwork-card__title">{artwork.title}</h3>
      {artwork.medium && (
        <span className="artwork-card__medium">{artwork.medium}</span>
      )}
      <span className="artwork-card__price">
        {artwork.type === 'Original' ? 'Inquire' : artwork.price}
      </span>
    </div>
  </Link>
);

export default ArtworkCard;
